
import { useNavigate } from 'react-router-dom';
import CallAPI from '../api';
import { useState } from 'react';
export default function useLogin(){
 const [email,setemail]=useState('');
 const [password,setpassword]=useState('');
 const [loading,setloading]=useState(false);
 const navigate=useNavigate();
 const handleEmailChange=(e)=>{
    setemail(e.target.value);
 }
 const handlePasswordChange=(e)=>{
    setpassword(e.target.value);
 }
 const login=async ()=>{
    setloading(true);
   try {
   const res=await CallAPI("login","post",{email,password});
    const token=res.data.token;
    const accountType=res.data.doc.accountType;
    const _id=res.data.doc._id;
    localStorage.setItem("access_token",token);
    localStorage.setItem("accountType",accountType);
    localStorage.setItem("_id",_id);
    navigate(`/dashboard/profile`);
   } catch (error) {
    console.log(error);
   }
   setloading(false)
 }

 return {email,password,loading,handleEmailChange,handlePasswordChange,login};
}